/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Prelim_After_FinalsInputs */



/**
* | output |
* | --- |
* | "Cannot start a preliminary round after finals" |
*
* @param {Err_Tournament_Prelim_After_FinalsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_prelim_after_finals = /** @type {((inputs?: Err_Tournament_Prelim_After_FinalsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Prelim_After_FinalsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible de démarrer une ronde préliminaire après la finale")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se puede iniciar una ronda preliminar después de las finales")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não é possível iniciar uma rodada preliminar após as finais")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile avviare un round preliminare dopo le finali")
	return /** @type {LocalizedString} */ ("Cannot start a preliminary round after finals")
});